const benefits = [
  {
    icon: "ri-medal-line",
    title: "Repuestos Originales y Homologados",
    desc: "Trabajamos exclusivamente con piezas de calidad certificada, originales de fábrica y homologadas para garantizar el rendimiento de tu Mitsubishi.",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "Asesoría Personalizada Experta",
    desc: "Nuestro equipo te guía para encontrar exactamente lo que necesitas, evitando errores costosos de compatibilidad.",
  },
  {
    icon: "ri-brain-line",
    title: "Amplio Conocimiento",
    desc: "Más de 40 años especializados en Mitsubishi nos dan un conocimiento profundo de cada modelo, versión y generación.",
  },
  {
    icon: "ri-global-line",
    title: "Importación de Repuestos",
    desc: "Si el repuesto no está en el mercado local, lo importamos. Accedemos a proveedores internacionales para conseguir repuestos que no se encuentren en el mercado local.",
  },
  {
    icon: "ri-whatsapp-line",
    title: "Atención Rápida por WhatsApp",
    desc: "Respuesta inmediata por WhatsApp. Sin filas, sin esperas. Cotiza desde donde estés en minutos.",
  },
  {
    icon: "ri-truck-line",
    title: "Envíos a Todo Colombia",
    desc: "Despachamos a cualquier ciudad del país. Tu repuesto llega seguro y a tiempo, sin importar dónde estés.",
  },
];

export default function BeneficiosSection() {
  return (
    <section className="bg-[#F7F7F7] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-14">
          <span className="text-[#E10600] text-xs font-black uppercase tracking-widest mb-3 block">
            Nuestras ventajas
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-black">
            ¿Por qué elegirnos?
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {benefits.map((b) => (
            <div
              key={b.title}
              className="bg-white rounded-xl p-8 group hover:border-t-4 hover:border-[#E10600] transition-all duration-300 hover:shadow-lg cursor-default"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-[#E10600]/10 rounded-xl mb-5 group-hover:bg-[#E10600] transition-colors duration-300">
                <i className={`${b.icon} text-[#E10600] text-2xl group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="text-lg font-black text-black mb-3">{b.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{b.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
